import List from 'containers/CompanySizes/List';
import Edit from 'containers/CompanySizes/Edit';
import Create from 'containers/CompanySizes/Create';
import Show from 'containers/CompanySizes/Show';

export default { List, Edit, Create, Show };
